import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Inject,
  Input,
  OnInit,
  Output,
  Renderer2,
  ViewChild,
} from '@angular/core';
import { Subject, Subscription } from 'rxjs';
import {
  addMonths,
  subMonths,
  startOfWeek,
  endOfWeek,
  endOfMonth,
  startOfMonth,
  add,
} from 'date-fns';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { environment } from 'src/environments/environment';
import { DataService } from 'src/app/shared/services/data.service';
import { UserAgentService } from 'src/app/shared/services/user-agent.service';
import { StudentDataType } from 'src/app/models/enums/StudentDataType';
import { ExamAndTaskCalenderItem } from 'src/app/models/ExamsAndTasksCalendar/examAndTaskCalenderItem';
import { CalendarEventItem } from 'src/app/models/ExamsAndTasksCalendar/calendarEventItem';
import { CalendarItemEnum } from 'src/app/models/enums/calendarItemType';
import { Filter } from '../../interfaces/filter';
import { DOCUMENT } from '@angular/common';
import { FilterItemComponent } from '../filter-item/filter-item.component';
import { switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import { CalendarEvent } from 'angular-calendar';
import { FiltersColorHelper } from 'src/app/utils/helpers/filtersColorHelper';
import { LocalizationService } from '../../services/localization.service';
import { ButtonStateService } from '../../services/button-state.service';


declare var gapi: any;
declare const popupsHandler: any;

@Component({
  selector: 'app-exams-calendar',
  templateUrl: './exams-calendar.component.html',
  styleUrls: [
    './exams-calendar.component.scss',
    './exams-calendar.component.en.scss',
  ],
  animations: [
    trigger('openClose', [
      state(
        'opened',
        style({
          height: '*',
        })
      ),
      state(
        'closed',
        style({
          height: 108,
        })
      ),
      transition('opened => closed', [animate('.2s')]),
      transition('closed => opened', [animate('0.2s')]),
    ]),
  ],
})
export class ExamsCalendarComponent implements OnInit {
  viewDate = new Date();
  events: CalendarEventItem[] = [];
  refresh = new Subject<void>();
  opened: boolean = false;
  isLoading: boolean = false;
  currentEvent!: CalendarEventItem | null;
  currentDate!: Date | null;
  @Input() closeEvents: EventEmitter<void> = new EventEmitter<void>();
  @Input() permissionKeys?: any = null;
  StudentDataType = StudentDataType;
  selectedCalendarTypes: StudentDataType[] = [
    StudentDataType.Exam,
    StudentDataType.Quiz,
    StudentDataType.Assignment,
    StudentDataType.Event,
    StudentDataType.Lesson,
  ];

  mobileWidth: boolean = false;
  FiltersColorHelper = FiltersColorHelper;
  LocalizationService = LocalizationService;

  @Input() mobileMode: boolean = false;
  @Input() disableDetailsShowing: boolean = false;
  @Input() showMobileFilters: boolean = false;
  @Input() showCurrentDayButton: boolean = true;
  @Input() filtersLabel!: string;
  @Input() currentDayButtonLabel!: string;
  @Input() studentCalendarFilters: any;
  @Input() notificationsHeaderText: string = '';
  @Input() timeRange: number[] = [];
  @HostListener('window:resize', ['$event']) onResize() {
    this.mobileWidth = this.userAgentService.isMobileDevice();
  }
  @HostBinding('class.mobile-mode') get mobile() {
    return this.mobileWidth || this.mobileMode;
  }
  @Output() dayItemClicked = new EventEmitter<Date>();
  @Output() serverErrorAppeared: EventEmitter<void> = new EventEmitter<void>();

  typeFilterItems: Filter[] = [
    {
      value: 'assignments',
      valueArr: [StudentDataType.Assignment],
      label: 'מטלות',
      color: FiltersColorHelper.defaultColorsList.assignments.primary,
      checked: true,
    },
    {
      value: 'exams and quizzes',
      valueArr: [StudentDataType.Exam, StudentDataType.Quiz],
      label: 'בחינות וחידונים',
      color: FiltersColorHelper.defaultColorsList.exams.primary,
      checked: true,
    },
    {
      value: 'lessons',
      valueArr: [StudentDataType.Lesson],
      label: 'שיעורים',
      color: FiltersColorHelper.defaultColorsList.lessons.primary,
      checked: true,
    },
    {
      value: 'academic events',
      valueArr: [StudentDataType.Event],
      label: 'אירועים אקדמיים',
      color: FiltersColorHelper.defaultColorsList.academicEvents.primary,
      checked: true,
    },
  ];

  private dataServiceSubscription: Subscription | null = null;

  firstLoading: boolean = true;
  isServerError: boolean = false;

  @ViewChild('typeFilter') typeFilterComponent!: FilterItemComponent;
  @Output() eventsLoded: EventEmitter<ExamAndTaskCalenderItem[]> =
    new EventEmitter<ExamAndTaskCalenderItem[]>();
  @Output() loadingStateChanged: EventEmitter<boolean> =
    new EventEmitter<boolean>();

  addToCalendarPopupData: any;

  constructor(
    private dataService: DataService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private document: Document,
    private userAgentService: UserAgentService,
    private buttonStateService: ButtonStateService
  ) {
    this.mobileWidth = this.userAgentService.isMobileDevice();
  }

  ngOnInit() {
    if (this.studentCalendarFilters) {
      this.typeFilterItems = FiltersColorHelper.convertToFilterArr(
        this.studentCalendarFilters
      );
      this.selectedCalendarTypes =
        FiltersColorHelper.convertStudentDataTypeToArr().filter((item) =>
          FiltersColorHelper.convertToCheckboxEnumArr(
            this.typeFilterItems
          ).includes(item)
        );
    }

    this.getData();
    this.dataService.updateAddToCalendarPopupData$.subscribe((value) => {
      this.addToCalendarPopupData = value;
    });
  }

  toggleCalendarState() {
    this.opened = !this.opened;
  }

  openEvent(event: CalendarEventItem, currentDate: Date) {
    this.closeEvents.emit();
    this.currentEvent = event;
    this.currentDate = currentDate;
  }

  closeEvent() {
    this.currentEvent = null;
    this.currentDate = null;
  }

  getData() {
    let url =
      environment.apiUrl +
      '/Portal/ExamsAndTasksCalendarBlockList/SearchExamsAndTasks';
    let rangeDates = this.getDisplayRangeDate();
    var request: any = {
      cultureCode: this.dataService.getCultureCode(),
      dataTypes: this.selectedCalendarTypes,
      fromDate: rangeDates[0],
      toDate: rangeDates[1],
      searchOneDay: false,
      term: null,
    };

    // Cancel the previous subscription (if any)
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }

    this.isLoading = true;
    this.loadingStateChanged.emit(this.isLoading);

    this.dataServiceSubscription = this.dataService
      .getDataByToken(url, request)
      .pipe(
        switchMap((responseData) => {
          this.events = [];
          if (responseData !== null) {
            let events: ExamAndTaskCalenderItem[] = responseData.map(
              (item: any) => item as ExamAndTaskCalenderItem
            );

            if (this.timeRange && this.timeRange.length > 0) {
              events = events.filter((event) => {
                let eventDate = new Date(event.date);
                let eventHour = eventDate.getHours();
                return this.timeRange.includes(eventHour);
              });
            }

            this.eventsLoded.emit(events);
            this.fillEvents(events);
          }
          this.isLoading = false;
          this.loadingStateChanged.emit(this.isLoading);
          this.firstLoading = false;
          return of(null);
        })
      )
      .subscribe({
        error: (e: any) => {
          console.error(e);
          this.isLoading = false;
          this.loadingStateChanged.emit(this.isLoading);
          this.firstLoading = false;
          this.isServerError = true;
          this.serverErrorAppeared.emit();
        },
      });
  }

  getDisplayRangeDate(): [Date, Date] {
    const timeZoneOffset = new Date().getTimezoneOffset();
    let startDate = startOfWeek(startOfMonth(this.viewDate), {
      weekStartsOn: 0,
    }); // 0 is for Sunday
    let endDate = endOfWeek(endOfMonth(this.viewDate), { weekStartsOn: 0 });
    let result: [Date, Date] = [
      add(startDate, { minutes: -timeZoneOffset }),
      add(endDate, { minutes: -timeZoneOffset }),
    ];
    return result;
  }

  fillEvents(data: ExamAndTaskCalenderItem[]) {
    this.events = [];
    let id = 1;
    data.forEach((item) => {
      let event: CalendarEventItem = {
        id: id,
        start: new Date(item.date),
        title: item.courseName ? item.courseName : item.name,
        allDay: true,
        eventData: item,
      };

      this.events.push(event);
      id++;
    });
  }

  getStringEnumForCheckbox(types: StudentDataType[]): string {
    return Object.values(types)
      .filter((value) => typeof value === 'number')
      .join(',');
  }

  todayBtnClick() {
    this.getData();
  }

  typeChange(event: any) {
    let checkboxEnums = event.source.value
      .split(',')
      .map(Number)
      .filter((value: string) =>
        Object.values(StudentDataType).includes(value)
      ) as StudentDataType[];

    if (event.checked) {
      this.selectedCalendarTypes.push(...checkboxEnums);
    } else {
      this.selectedCalendarTypes = this.selectedCalendarTypes.filter(
        (item) => !checkboxEnums.includes(item)
      );
    }

    this.getData();
  }

  monthChange(direction: string) {
    this.getData();
  }

  isTimeEmpty(dateTime: string): boolean {
    return dateTime.endsWith('T00:00:00Z');
  }

  addToCalendarEvent(type: CalendarItemEnum) {
    if (this.events.length == 0 || !this.permissionKeys) return;

    switch (type) {
      case CalendarItemEnum.Gmail:
        this.addToGoogleCalendar();
        break;
      case CalendarItemEnum.Desktop:
        this.generateICSFileAllEventsForDesktopCalender();
        break;
      case CalendarItemEnum.Outlook:
        break;
      case CalendarItemEnum.Yahoo:
        break;
    }
  }

  generateICSFileAllEventsForDesktopCalender() {
    let icsContent = this.generateICSContent();
    let blob = new Blob([icsContent], { type: 'text/calendar' });
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', 'Exam schedule and assignments.ics');
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
  }

  generateICSContent(): string {
    let icsContent = 'BEGIN:VCALENDAR\nVERSION:2.0\nPRODID:BGU\n';
    this.events.forEach((event) => {
      icsContent += 'BEGIN:VEVENT\n';
      icsContent += 'UID:' + new Date().getTime() + event.id + '\n';
      icsContent +=
        'DTSTART;VALUE=DATE:' +
        event.eventData.date.replace(/[-:]/g, '') +
        '\n';
      icsContent += 'SUMMARY:' + event.title + '\n';
      if (event.eventData.location) {
        icsContent += 'LOCATION:' + event.eventData.location + '\n';
      }
      icsContent += 'DESCRIPTION:' + event.eventData.description + '\n';
      icsContent += 'END:VEVENT\n';
    });

    icsContent += 'END:VCALENDAR';
    return icsContent;
  }

  addToGoogleCalendar() {
    if (!this.permissionKeys.google) return;
    // Disable the button
    this.buttonStateService.setButtonDisabled(true);

    const { clientId, apiKey, scopes } = this.permissionKeys.google;
    const DISCOVERY_DOCS = [
      'https://www.googleapis.com/discovery/v1/apis/calendar/v3/rest',
    ];

    const showPopup = (
      title: string,
      description: string,
      type: 'success-popup' | 'error-popup',
      iconUrl: string
    ) => {
      popupsHandler.popupMessage(title, description, '', type, iconUrl, [
        {
          label: type === 'success-popup' ? 'OK' : 'Close',
          callback: () => popupsHandler.closePopup(),
        },
      ]);
    };

    gapi.load('client', () => {
      gapi.client.init({
        apiKey,
        discoveryDocs: DISCOVERY_DOCS,
      });
    });

    const tokenClient = (window as any).google.accounts.oauth2.initTokenClient({
      client_id: clientId,
      scope: scopes,
      callback: async (resp: any) => {
        if (resp.error !== undefined) {
          showPopup(
            this.addToCalendarPopupData.addToCalendarFailureTitle,
            this.addToCalendarPopupData.addToCalendarFailureDescription,
            'error-popup',
            this.addToCalendarPopupData.addToCalendarFailureIconUrl
          );
          this.buttonStateService.setButtonDisabled(false); // Re-enable on error
          throw resp;
        }

        try {
          const sendEvents = this.generateEventsJsonForCalendar();

          sendEvents.forEach((event) => {
            const request = gapi.client.calendar.events.insert({
              calendarId: 'primary',
              resource: event,
            });
            request.execute((event: any) => {});
          });

          showPopup(
            this.addToCalendarPopupData.addToCalendarSuccessTitle,
            this.addToCalendarPopupData.addToCalendarSuccessDescription,
            'success-popup',
            this.addToCalendarPopupData.addToCalendarSuccessIconUrl
          );
        } catch (error) {
          console.error(error);
          showPopup(
            this.addToCalendarPopupData.addToCalendarFailureTitle,
            this.addToCalendarPopupData.addToCalendarFailureDescription,
            'error-popup',
            this.addToCalendarPopupData.addToCalendarFailureIconUrl
          );
        } finally {
          this.buttonStateService.setButtonDisabled(false); // Re-enable on error
        }
      },
    });

    setTimeout(() => {
      if (gapi.client.getToken() === null) {
        tokenClient.requestAccessToken({ prompt: 'consent' });
      } else {
        tokenClient.requestAccessToken({ prompt: '' });
      }
    }, 1000);
  }

  generateEventsJsonForCalendar(): any[] {
    let events: any[] = [];
    this.events.forEach((event) => {
      let nEvent = {
        summary: event.title,
        start: {
          dateTime: event.eventData.date,
          timeZone: 'Israel',
        },
        end: {
          dateTime: event.eventData.date,
          timeZone: 'Israel',
        },
        description: event.eventData.description,
      };
      if (event.eventData.location) {
        let nnEvent = {
          ...nEvent,
          location: event.eventData.location,
        };
        events.push(nnEvent);
      } else {
        events.push(nEvent);
      }
    });
    return events;
  }

  mobileTypeFilterChange(filters: Filter[]) {
    this.typeFilterItems = filters;
    let checkboxEnums = filters
      .filter((c) => c.checked)
      .reduce<StudentDataType[]>(
        (acc, filter) => [...acc, ...filter.valueArr!],
        []
      );
    let enumToArray: StudentDataType[] = Object.keys(StudentDataType)
      .filter((key) => isNaN(Number(key)))
      .map(
        (key) => StudentDataType[key as any]
      ) as unknown as StudentDataType[];
    this.selectedCalendarTypes = enumToArray.filter((item) =>
      checkboxEnums.includes(item)
    );
    this.getData();
  }

  closeOpenMobileFilter(state: boolean) {
    let mainMobileContainer = this.document.querySelector(
      'app-widget-grid-card.mobile-modal .card-component-wrap'
    );
    if (mainMobileContainer) {
      if (state) {
        this.renderer.setStyle(mainMobileContainer, 'z-index', '0');
      } else {
        this.renderer.removeStyle(mainMobileContainer, 'z-index');
      }
    }
  }

  dayClicked(day: Date) {
    this.dayItemClicked.emit(day);
  }
}
